import { render, staticRenderFns } from "./DnsItems.vue?vue&type=template&id=1c170e88"
import script from "./DnsItems.vue?vue&type=script&lang=js"
export * from "./DnsItems.vue?vue&type=script&lang=js"
import style0 from "./DnsItems.vue?vue&type=style&index=0&id=1c170e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports